<div class="top-panel">
  @for (group of fabGroups; track group.class) {
    <div [class]="group.class">
      @for (fab of group.buttons; track fab.key) {
        @if (!fab.visible || fab.visible()) {
          <div class="fab-wrapper" [matTooltip]="fab.tooltip()">
            <button
              libButton
              variant="primary"
              size="xs"
              type="button"
              class="!size-9 !p-0"
              [attr.aria-label]="fab.ariaLabel()"
              [disabled]="fab.disabled()"
              (click)="fab.onClick()">
              <mat-icon class="size-4!" [svgIcon]="fab.icon()"></mat-icon>
            </button>
          </div>
        }
      }
    </div>
  }

  <div class="download-panel" [matTooltip]="downloadTooltip">
    <button
      libButton
      variant="primary"
      size="xs"
      type="button"
      class="!h-9"
      [attr.aria-label]="downloadTooltip"
      [disabled]="!canDownload"
      (click)="download.emit()">
      <mat-icon class="size-4!" svgIcon="download"></mat-icon>
      <span class="download-label">{{ 'EDITOR.TOP_PANEL.DOWNLOAD' | translate }}</span>
    </button>
  </div>
</div>
